import BackLinkButton from "components/front/mypage/layout/BackLinkButton";
import { useActivation } from "lib/hooks/useActivation";
import { useOrderSummaryList } from "lib/hooks/useOrderSummaryList";
import { FrontOrderService } from "lib/service/client/FrontOrderService";
import { useRouter } from "next/router";
import React, { useMemo, useState } from "react";
import { Loading } from "components/front/layout/Loading";
import { SUPPORT_TAB } from "./MypageTabs";
import { GroupedOrderListArea } from "./order/GroupedOrderListArea";
import OrderArea from "components/front/mypage/order/OrderArea";
import styled from "styled-components";
import { Order } from "interfaces/front/page/mypage/supportPanel";

export type Props = {
  selectedTab: string;
};
const SupportPanel: React.FC<Props> = ({ selectedTab }) => {
  const { activated, deactivate, onSelectOrder, order, orderSummaryList } = useSupportPanelStates();
  return selectedTab === SUPPORT_TAB ? (
    <Root>
      {orderSummaryList ? (
        orderSummaryList.length > 0 ? (
          <>
            <ListContainer $activated={activated}>
              <GroupedOrderListArea
                orderSummaries={orderSummaryList}
                serviceType="crowd_funding"
                label="クラウドファンディング"
                onSelectItem={onSelectOrder}
              />
              <GroupedOrderListArea
                orderSummaries={orderSummaryList}
                serviceType="hometown_tax"
                label="ふるさと納税"
                onSelectItem={onSelectOrder}
              />
              <GroupedOrderListArea
                orderSummaries={orderSummaryList}
                serviceType="corp_hometown_tax"
                label="企業版ふるさと納税"
                onSelectItem={onSelectOrder}
              />
              <GroupedOrderListArea
                orderSummaries={orderSummaryList}
                serviceType="shopping"
                label="アニメショッピング"
                onSelectItem={onSelectOrder}
                isShopping={true}
              />
            </ListContainer>
            {order && (
              <DetailContainer $activated={activated}>
                <BackLinkButton onClick={deactivate} />
                <OrderArea order={order} />
              </DetailContainer>
            )}
          </>
        ) : (
          <div>まだ何も応援していません。</div>
        )
      ) : (
        <Loading />
      )}
    </Root>
  ) : (
    <></>
  );
};
export default SupportPanel;

const useSupportPanelStates = () => {
  const [activated, activate, deactivate] = useActivation(false);
  const router = useRouter();
  const service = useMemo(() => new FrontOrderService(router), []);
  const orderSummaryList = useOrderSummaryList(service);
  const [order, setOrder] = useState<Order>();
  const onSelectOrder = async (orderCode: string) => {
    await service.get(orderCode, setOrder);
    activate();
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  return { activated, deactivate, orderSummaryList, order, onSelectOrder };
};

const Root = styled.div`
  background-color: #fff;
  padding: 20px;
  min-height: 600px;
  @media screen and (max-width: 960px) {
    padding: 20px 10px;
  }
  @media screen and (min-width: 961px) {
    display: flex;
    justify-content: space-between;
  }
`;

const ListContainer = styled.div<{ $activated: boolean }>`
  @media screen and (max-width: 960px) {
    width: 100%;
    display: ${({ $activated }) => ($activated ? "none" : "block")};
  }
  @media screen and (min-width: 961px) {
    min-width: 288px;
    width: 288px;
  }
  @media screen and (min-width: 1281px) {
    min-width: 360px;
    width: 360px;
  }
  @media screen and (min-width: 1921px) {
    min-width: 390px;
    width: 390px;
  }
`;

const DetailContainer = styled.div<{ $activated: boolean }>`
  @media screen and (min-width: 961px) {
    flex-grow: 2;
    margin-left: 20px;
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    display: ${({ $activated }) => ($activated ? "block" : "none")};
  }
`;
